
<div class="pin-description-container">
    <h1 mat-dialog-title class="header">{{ 'PIN-DESCRIPTION-DIALOG.PIN-TITLE' | translate }}</h1>
    <form [formGroup]="pinForm" (ngSubmit)="onSubmit()">
        <div mat-dialog-content>
            <p class="description-pin">{{ 'PIN-DESCRIPTION-DIALOG.PIN-NAME' | translate }}</p>
            <mat-form-field class="description-pin-text-field">
                <mat-label>{{ 'PIN-DESCRIPTION-DIALOG.DESCRIPTION' | translate }}</mat-label>
                <input matInput formControlName="newDescription" required>
            </mat-form-field>
        </div>
        <div mat-dialog-actions>
            <button class="pin-descript" mat-flat-button  type="submit">{{ 'PIN-DESCRIPTION-DIALOG.OK' | translate }}</button>
            <button class="pin-descript" mat-flat-button  (click)="cancel()" type="button">{{ 'DATE-RANGE-DIALOG.CANCEL' | translate }}</button>
        </div>
    </form>

</div>

